<script>
export default {
  props: { 
    isVisible: { type: Boolean, default: false },
    orderVersion: { type: String, default: 's' }
  },
  data() {
    return {
      showTab: 1,
      completedTab1Once: false,
      showUpperHeaderText: false,
      versions: {
        s: { name: 'Jante', price: '150 kr', logo: 'jamii_logo_jante.png' }, 
        m: { name: 'Lagom', price: '300 kr', logo: 'jamii_logo_lagon.png'}, 
        l:{ name: 'Märkvärdig', price: 'från 700 kr', logo: 'jamii_logo_markvardig.png'} 
      },
      orderItem: { 
        first_name: null, 
        last_name: null, 
        email: null, 
        mobile_no: null, 
        name: null, 
        street: null, 
        postal_code: null, 
        town: null, 
        confirm: false, 
        is_trial: false       
      },
      validationErrors: [],
      showConfirmationMissing: false,
      propNames: { 
        first_name: 'Förnamn', 
        last_name: 'Efternamn', 
        email: 'Email', 
        name: 'Föreningens namn', 
        street: 'Gata', 
        postal_code: 'Postnummer', 
        town: 'Stad'
      },
      orderSuccess: false
    }
  },
  methods: {
    handleScroll(e) {
      this.showUpperHeaderText = e.srcElement.scrollTop > 420;  
    },
    closeModal() {
      this.$emit('close');
    },
    goToTab2() {
      this.validationErrors = [];
      for (const prop in this.orderItem) {
        if(this.orderItem[prop] == null && prop != 'mobile_no') {
          this.validationErrors.push(prop);
        }
      }

      if(this.validationErrors.length == 0) {
        this.showTab = 2;
        this.completedTab1Once = true;
      }
    },
    order() {
      this.showConfirmationMissing = false;
      if(!this.orderItem.confirm) {
        this.showConfirmationMissing = true;
        return;
      }

      this.orderItem.order_version = this.versions[this.orderVersion].name
      var self = this;
      this.$communicator.post("order/", this.orderItem)
      .then(function(data) {
        self.orderSuccess = true;
      })
      .fail(function(error) {
        // Handle error
      }); 
    }
  },
  computed: {
      modalHeight(){
      return (window.innerHeight - 140) + "px";
    }
  },
  watch: {
    isVisible(newVal) {
      if (!newVal) {
        // Reset form when modal closes
        this.showTab = 1;
        this.completedTab1Once = false;
        this.orderSuccess = false;
        this.validationErrors = [];
        this.showConfirmationMissing = false;
        this.orderItem = { 
          first_name: null, 
          last_name: null, 
          email: null, 
          mobile_no: null, 
          name: null, 
          street: null, 
          postal_code: null, 
          town: null, 
          confirm: false, 
          is_trial: false 
        };
      }
    }
  }
}
</script>
<template>
  <div v-if="isVisible" class="order-modal-overlay" @click.self="closeModal">
    <div class="order-modal-content"  :style="{ 'height': modalHeight }">
      <div class="upper-header">
        <button class="close-button" @click="closeModal">X</button>
        <!-- <div class="upper-target-text" v-if="showUpperHeaderText" v-fade-in(100)>       
            <div class="price-highlight" style="padding: 5px 10px 7px 10px;margin: 7px;border-radius: 20px;">
              <span class="price"> JAMII {{ versions[orderVersion].name }} &nbsp; {{ versions[orderVersion].price }}</span>
              <span class="period">per månad</span>
              <span class="billing">(faktureras årsvis)</span>
            </div>
          </div> -->
      </div>
      <div class="modal-text" @scroll="handleScroll">    
        <div v-if="!orderSuccess" class="order-form">
          <h2 class="modal-heading">
            <span>Beställ </span>
            <img v-if="orderVersion == 's'"  src="@/assets/imgs/sale/jamii_logo_jante.png" />
            <img v-if="orderVersion == 'm'" src="@/assets/imgs/sale/jamii_logo_lagom.png" />
            <img v-if="orderVersion == 'l'" src="@/assets/imgs/sale/jamii_logo_markvardig.png" />
          </h2>
          <p class="modal-subtitle">Digitalisera er idag</p>
          
          <div class="intro-box">
            <h3>Välkommen till JAMII!</h3>
            <p>Tack för att du väljer JAMII {{ versions[orderVersion].name }} för din förening! Genom att prenumerera på vår tjänst får du omedelbar tillgång till våra avancerade digitala verktyg.</p>
            <div class="price-highlight">
              <span class="price">{{ versions[orderVersion].price }}</span>
              <span class="period">per månad</span>
              <span class="billing">(faktureras årsvis)</span>
            </div>
          </div>

          <div class="step-section">
            <div class="step-header" :class="{ active: showTab == 1, completed: completedTab1Once }" @click="showTab = 1">
              <span class="step-number">1</span>
              <span>Kontaktuppgifter</span>
            </div>
            
            <div v-if="showTab == 1" class="step-content">
              <div class="form-group">
                <h4>Kontaktperson</h4>
                <div class="form-row">
                  <div class="form-field">
                    <label>Förnamn <span class="required">*</span></label>
                    <input type="text" v-model="orderItem.first_name"/>
                  </div>
                  <div class="form-field">
                    <label>Efternamn <span class="required">*</span></label>
                    <input type="text" v-model="orderItem.last_name"/>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-field">
                    <label>Email <span class="required">*</span></label>
                    <input type="text" v-model="orderItem.email"/>
                  </div>
                  <div class="form-field">
                    <label>Telefon</label>
                    <input type="text" v-model="orderItem.mobile_no"/>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <h4>Föreningens namn <span class="required">*</span></h4>
                <input type="text" v-model="orderItem.name"/>
              </div>

              <div class="form-group">
                <h4>Föreningens adress <span class="required">*</span></h4>
                <input type="text" placeholder="Gata" v-model="orderItem.street"/>
                <div class="form-row">
                  <div class="form-field form-field-small">
                    <input type="text" placeholder="Postnummer" v-model="orderItem.postal_code"/>
                  </div>
                  <div class="form-field form-field-large">
                    <input type="text" placeholder="Ort" v-model="orderItem.town"/>
                  </div>
                </div>
              </div>

              <p class="required-note"><span class="required">*</span> = obligatoriskt fält</p>

              <div class="error-box" v-if="validationErrors.length">
                <p>Oj, det ser ut som att du glömt att mata in något obligatoriskt fält:</p>
                <ul>
                  <li v-for="error in validationErrors" :key="error">{{ propNames[error] }}</li>
                </ul>
              </div>

              <button v-if="!completedTab1Once" @click="goToTab2" class="next-button">Vidare till nästa steg</button>
            </div>

            <div class="step-header" :class="{ active: showTab == 2 }" @click="showTab = 2" v-show="completedTab1Once">
              <span class="step-number">2</span>
              <span>Sammanfattning</span>
            </div>

            <div v-if="showTab == 2" class="step-content">
              <h4>Beställningsdetaljer</h4>
              <div class="order-summary">
                <div class="summary-item"><strong>Förnamn:</strong> {{ orderItem.first_name }}</div>
                <div class="summary-item"><strong>Efternamn:</strong> {{ orderItem.last_name }}</div>
                <div class="summary-item"><strong>Email:</strong> {{ orderItem.email }}</div>
                <div class="summary-item"><strong>Telefon:</strong> {{ orderItem.mobile_no }}</div>
                <div class="summary-item"><strong>Föreningens namn:</strong> {{ orderItem.name }}</div>
                <div class="summary-item"><strong>Adress:</strong> {{ orderItem.street }}, {{ orderItem.postal_code }} {{ orderItem.town }}</div>
              </div>

              <div class="form-group">
                <h4>Användarvillkor</h4>
                <div class="terms-box">
                  <p><strong>Genom att godkänna dessa villkor accepterar du följande:</strong></p>
                  <ul class="terms-list">
                    <li>Du samtycker till att använda JAMII enligt gällande lagar och regler samt våra användarriktlinjer.</li>
                    <li>Du förstår att information som delas på plattformen kan vara tillgänglig för andra användare inom din förening.</li>
                    <li>Du samtycker till behandling av personuppgifter i enlighet med vår integritetspolicy.</li>
                    <li>Eventuella betalningar för tjänsten regleras enligt de betalningsvillkor som anges.</li>
                  </ul>
                  <a href="jamii_avtal.pdf" target="_blank"> Läs hela avtalet här</a>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="orderItem.confirm" />
                    Jag godkänner användarvillkoren.
                  </label>
                </div>
              </div>

              <div class="error-box" v-if="showConfirmationMissing">
                <p>Du måste godkänna villkoren</p>
              </div>

              <button @click="order" class="order-button">Beställ</button>
            </div>
          </div>
        </div>

        <div v-if="orderSuccess" class="success-content">
          <div class="success-icon">✓</div>
          <h2>Beställningen är skickad!</h2>
          <div class="success-text">
            <p>Så kul att ni valt att digitalisera er förening med oss på JAMII!</p>
            <p>En bekräftelse kommer att skickas ut till angiven e-mail och senast inom ett dygn kommer ni få inloggningsuppgifterna.</p>
            <p>Har ni några frågor eller något ni undrar över är det bara att höra av sig till <a href="mailto:admin@jamii.se">admin@jamii.se</a>.</p>
            <p class="signature">Vi ses i JAMII!<br><br>//JAMII-gänget</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.order-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(18, 76, 61, 0.9);
  backdrop-filter: blur(5px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.2s ease-out;
  overflow-y: auto;
  padding: 10px;
}

.upper-header {
  position: absolute; 
  top: 0px; 
  left: 0px; 
  width: 100%;
}

.modal-text {
  flex: 1;
  overflow-y: auto;
  margin-top: 35px;
  padding-right: 10px;
}

.modal-text::-webkit-scrollbar {
  width: 15px;      
}

.modal-text::-webkit-scrollbar-track {
  background: transparent; 
}

.modal-text::-webkit-scrollbar-thumb {
  background-color: #888;  
  border-radius: 15px;      
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.order-modal-content {
  background: white;
  padding: 20px;
  border-radius: 30px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  color: #063227;
  border: 3px solid #f25c43;
  animation: slideIn 0.3s ease-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.close-button {
  float:right;
  background: #f25c43;
  border: 2px solid #f25c43;
  font-size: 16px;
  cursor: pointer;
  color: white;
  border-radius: 31px;
  width: 35px;
  height: 35px;
  margin: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  transition: all 0.2s ease;
}

.close-button:hover {
  background: white;
  color: #f25c43;
  border-color: white;
}

.modal-heading {
  font-family: "Barlow Condensed", serif;
  font-weight: 700;
  font-size: 3rem;
  margin-bottom: 10px;
  color: #124c3d;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-heading img {
  height: 70px;
}

.modal-heading span {
  display:inline-block;
  margin-right: 10px;
}

.modal-subtitle {
  font-size: 1.1rem;
  color: #063227;
  opacity: 0.8;
  text-align: center;
  margin-bottom: 30px;
}

.intro-box {
  background: #e0d9bd;
  padding: 25px;
  border-radius: 20px;
  margin-bottom: 30px;
  text-align: center;
}

.intro-box h3 {
  font-family: "Barlow Condensed", serif;
  font-weight: 600;
  font-size: 1.5rem;
  margin-bottom: 15px;
  color: #063227;
}

.intro-box p {
  margin-bottom: 20px;
  line-height: 1.5;
}

.price-highlight {
  background: #f25c43;
  color: white;
  padding: 15px 25px;
  border-radius: 15px;
  display: inline-block;
}

.price {
  font-family: "Barlow Condensed", serif;
  font-size: 1.8rem;
  font-weight: 700;
  margin-right: 8px;
}

.period {
  font-size: 1rem;
  margin-right: 8px;
}

.billing {
  font-size: 0.9rem;
  opacity: 0.9;
}

.step-header {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border: 2px solid #ddd;
  border-radius: 15px;
  padding: 15px 20px;
  margin: 20px 0 15px 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-header.active {
  background: #124c3d;
  border-color: #f25c43;
  color: white;
}

.step-header.completed {
  background: #e0d9bd;
  border-color: #f25c43;
  color: #063227;
}

.step-number {
  background: #f25c43;
  color: white;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  margin-right: 15px;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

.step-content {
  padding: 0 0 20px 0;
}

.form-group {
  margin-bottom: 25px;
}

.form-group h4 {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  margin-bottom: 15px;
  color: #124c3d;
}

.form-row {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.form-field {
  flex: 1;
}

.form-field-small {
  flex: 0 0 30%;
}

.form-field-large {
  flex: 1;
}

.form-field label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: #063227;
  font-family: "Poppins", sans-serif;
  font-size: 14px;
}

.required {
  color: #f25c43;
  font-weight: 700;
}

.required-note {
  font-size: 14px;
  color: #666;
  margin-bottom: 20px;
}

input {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  padding: 10px 12px;
  border: 2px solid #e0d9bd;
  border-radius: 8px;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.3s ease;
}

input:focus {
  outline: none;
  border-color: #f25c43;
}

.order-summary {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 25px;
  border-left: 4px solid #f25c43;
}

.summary-item {
  padding: 5px 0;
  border-bottom: 1px solid #e9ecef;
}

.summary-item:last-child {
  border-bottom: none;
}

.terms-box {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 10px;
  border: 1px solid #e0d9bd;
}

.terms-list {
  margin: 15px 0;
  padding-left: 20px;
}

.terms-list li {
  margin-bottom: 8px;
  line-height: 1.4;
}

.checkbox-label {
  display: flex;
  align-items: center;
  margin-top: 15px;
  font-weight: 500;
}

.checkbox-label input {
  width: auto;
  margin-right: 10px;
}

.error-box {
  background: #f8d7da;
  border: 2px solid #dc3545;
  color: #721c24;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 20px;
}

.error-box ul {
  margin: 10px 0 0 20px;
}

.next-button, .order-button {
  background: #f25c43;
  color: white;
  border: 2px solid #f25c43;
  padding: 12px 30px;
  border-radius: 25px;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.next-button:hover, .order-button:hover {
  background: white;
  color: #f25c43;
}

.success-content {
  text-align: center;
  padding: 20px;
}

.success-icon {
  background: #f25c43;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 auto 25px;
}

.success-content h2 {
  font-family: "Barlow Condensed", serif;
  font-weight: 700;
  font-size: 2rem;
  margin-bottom: 25px;
  color: #124c3d;
}

.success-text p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.signature {
  font-style: italic;
  margin-top: 25px;
  color: #124c3d;
}

/* Responsive */
@media (max-width: 768px) {
  .order-modal-content {
    padding: 25px 20px;
    margin: 10px;
  }
  
  .modal-heading {
    font-size: 2.5rem;
    flex-direction: column;
  }

  
  .form-row {
    flex-direction: column;
    gap: 10px;
  }
  
  .form-field-small, .form-field-large {
    flex: none;
  }
}
</style>
